"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    kodelisteId: function() {
        return kodelisteId;
    },
    kodeliste: function() {
        return kodeliste;
    }
});
var _transformKonstanter = require("./transformKonstanter");
var _utils = require("../../utils");
var kodelisteId = function(id) {
    return "kodeliste.".concat(id);
};
var kodeliste = {
    navn: "Oppslag i kodeliste",
    description: "Sl\xe5r opp verdien i gitt kodeliste",
    verditype: _transformKonstanter.verditype.enkelt,
    transform: function(felt, verdi) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var _felt_opsjon;
        var kodeId;
        var nyVerdi = (0, _utils.removeLeadingZeros)(verdi, felt);
        if (felt.transformer.kodeliste === "Egendefinert") {
            var tekstId = felt.tekstId || felt.id;
            kodeId = "".concat(felt.transformer.kodeliste, ".").concat(tekstId, ".").concat(nyVerdi);
        } else {
            kodeId = nyVerdi ? "".concat(felt.transformer.kodeliste, ".").concat(nyVerdi) : "".concat(felt.transformer.kodeliste);
        }
        if (options.returnerId) {
            return kodelisteId(kodeId);
        }
        if (((_felt_opsjon = felt.opsjon) === null || _felt_opsjon === void 0 ? void 0 : _felt_opsjon.type) === "avkrysningsboks") {
            kodeId = "".concat(nyVerdi) === "true" ? "boolsk.ja" : "boolsk.nei";
        }
        var transformert = options.intl.formatMessage({
            id: kodelisteId(kodeId),
            defaultMessage: nyVerdi
        });
        return felt.transformer.visId ? "".concat(transformert, " (").concat(nyVerdi, ")") : transformert;
    }
};
